// src/Components/SideBarNav/AccountantBackOfficeMenu.tsx
import React from 'react';
import NavItem from './NavItem';
import { PaymentsIcon, DocumentsIcon, CalendarIcon } from 'assets/icons';

interface AccountantBackOfficeMenuProps {
  isTaxExpanded: boolean;
  setIsTaxExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isFinCenExpanded: boolean;
  setIsFinCenExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  handleToggle: (
    setter: React.Dispatch<React.SetStateAction<boolean>>,
  ) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export default function AccountantBackOfficeMenu(
  props: AccountantBackOfficeMenuProps,
) {
  return (
    <>
      <NavItem
        icon={PaymentsIcon}
        name="Payments"
        path="/dashboard/payments"
        className="custom-menu-item"
      />
      <NavItem
        icon={DocumentsIcon}
        name="Documents"
        path="/dashboard/documents"
        className="custom-menu-item"
      />
      <NavItem
        icon={CalendarIcon}
        name="Calendar"
        path="/dashboard/calendar"
        className="custom-menu-item"
      />
    </>
  );
}
